import { Injectable, inject } from '@angular/core';
import { AbsencePlannerEventModel } from '../../../../core/models/absence-planner/absence-planner-event.model';
import { AbsencePlannerService } from '../../services/absence-planner.service';
import { assert } from '../../../../core/assert/assert';
import { AbsencePlannerEventComponentHandlerService } from './absence-planner-event-component-handler.service';
import { clone } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class AbsencePlannerEventCrudService {
  private readonly absencePlannerService = inject(AbsencePlannerService);
  private readonly plannerEventComponentHandlerService = inject(
    AbsencePlannerEventComponentHandlerService,
  );

  /**
   * Returns a writable shallow copy of the planner event model.
   */
  public selectPlannerEvent(id: number): AbsencePlannerEventModel {
    const plannerEventModels = this.absencePlannerService.plannerModel.plannerEventModels;
    const selectedPlannerEvent = plannerEventModels().find((p) => p.id === id);

    assert(typeof selectedPlannerEvent !== 'undefined', 'Planner event was not found.');

    return clone(selectedPlannerEvent);
  }

  /**
   * Add planner event model to the collection and build component
   */
  public addPlannerEvent(newPlannerEventModel: AbsencePlannerEventModel): void {
    const clonedModel = clone(newPlannerEventModel);

    clonedModel.componentRef =
      this.plannerEventComponentHandlerService.buildComponent(newPlannerEventModel);

    if (clonedModel.componentRef) {
      const plannerEventModels = this.absencePlannerService.plannerModel.plannerEventModels;
      plannerEventModels.update((plannerEvents) => [...plannerEvents, clonedModel]);
    }
  }

  /**
   * Update planner event model in the collection
   */
  public updatePlannerEvent(updatedPlannerEvent: AbsencePlannerEventModel): void {
    const plannerEventModels = this.absencePlannerService.plannerModel.plannerEventModels;
    const index = plannerEventModels().findIndex((p) => p.id === updatedPlannerEvent.id);
    assert(index >= 0, 'Planner event was not found.');
    plannerEventModels.update((plannerEvents) =>
      plannerEvents.toSpliced(index, 1, updatedPlannerEvent),
    );
  }

  /**
   * Remove planner event model from the collection and destroy component
   */
  public removePlannerEvent(plannerEventModel: AbsencePlannerEventModel): void {
    this.plannerEventComponentHandlerService.removeComponent(plannerEventModel);
    const plannerEventModels = this.absencePlannerService.plannerModel.plannerEventModels;
    const index = plannerEventModels().findIndex((p) => p.id === plannerEventModel.id);
    assert(index >= 0, 'Planner event was not found.');
    plannerEventModels.update((plannerEvents) => plannerEvents.toSpliced(index, 1));
  }
}
